/**
 * IA-R4/R8/R9 — Incident Workspace / Engine chrome (shared spine labels).
 * Prefer incidentEngineHostHtml for AI-depth spines; this stays for light shells.
 */
import { escapeHtml } from "./dom.js";

/** @type {ReadonlyArray<{ id: string, label: string }>} */
export const INCIDENT_WORKSPACE_SPINE = Object.freeze([
  { id: "observation", label: "Observation" },
  { id: "assessment", label: "Assessment" },
  { id: "recommendation", label: "Recommendation" },
  { id: "decision", label: "Decision" },
  { id: "execution", label: "Execution" },
  { id: "evidence", label: "Evidence" },
  { id: "timeline", label: "Timeline" },
]);

/**
 * @param {{ activeId?: string, incidentId?: string, title?: string }} [opts]
 */
export function incidentWorkspaceSpineHtml(opts = {}) {
  const active = String(opts.activeId || "decision").trim().toLowerCase();
  const title = String(opts.title || "Tonight's plan").trim();
  const id = String(opts.incidentId || "").trim();
  const pills = INCIDENT_WORKSPACE_SPINE.map((s) => {
    const on = s.id === active;
    return `<span class="croc-iw-spine__step${on ? " is-active" : ""}"${on ? ' aria-current="step"' : ""}>${escapeHtml(s.label)}</span>`;
  }).join("");
  return `
  <header class="croc-iw-chrome glass-panel glass-panel--inset" data-incident-workspace="1" data-incident-engine="1" data-iw-id="${escapeHtml(id)}">
    <div class="croc-iw-chrome__head">
      <p class="croc-iw-chrome__eyebrow">Tonight's plan</p>
      <h3 class="croc-iw-chrome__title">${escapeHtml(title)}</h3>
      <p class="muted croc-iw-chrome__lede">One place on the map · Continue or Hold is the only next step</p>
    </div>
    <nav class="croc-iw-spine" aria-label="Tonight's plan">${pills}</nav>
  </header>`;
}
